import { useCallback, useEffect, useMemo, useState } from "react";
import { GiPassport } from "react-icons/gi";
import { IoMdGlobe } from "react-icons/io";

import i18next from "i18next";
import getVisaInfo, { getCountries } from "../../../info/getVisaInfo";
import { RenderResultSection } from "./ResultSectionComponent";
import { SearchableSelect } from "./SearchableSelectComponent";
import { Container, ContainerLeft, FormContainer, Header, Subtitle, Title } from "./style";

export const VisaFreeComponent = () => {
  const { t, language } = i18next;
  const [citizenship, setCitizenship] = useState("");
  const [destination, setDestination] = useState("");
  const [result, setResult] = useState(null);
  const [countries, setCountries] = useState({});
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const loadCountries = async () => {
      try {
        const countriesData = await getCountries();
        setCountries(countriesData || {});
      } catch (error) {
        console.error("Error loading countries:", error);
      }
    };
    loadCountries();
  }, []);

  const countriesList = useMemo(() => {
    return Object.entries(countries).map(([code, data]) => ({
      code,
      flag: data.flag,
      name: data.name[language],
      default_country: data.default_country,
    }));
  }, [countries, language]);

  const handleSearch = useCallback(async () => {
    if (citizenship && destination) {
      setLoading(true);
      try {
        const info = await getVisaInfo(citizenship, destination);
        setResult(info);
      } catch (error) {
        console.error("Error getting visa info:", error);
        setResult({
          visa_type: "no-data",
          message: "Ошибка при получении данных о визе",
        });
      } finally {
        setLoading(false);
      }
    }
  }, [citizenship, destination]);

  useEffect(() => {
    if (citizenship && destination) {
      handleSearch();
    } else {
      setResult(null);
    }
  }, [citizenship, destination, handleSearch]);

  const getResultType = useCallback(() => {
    if (result?.visa_type === null) return "no-data";
    return result?.visa_type;
  }, [result]);

  return (
    <Container>
      <ContainerLeft>
        <Header>
          <Title>{t("get_visa_title")}</Title>
          <Subtitle>{t("get_visa_subtitle")}</Subtitle>
        </Header>

        <FormContainer>
          <SearchableSelect
            value={citizenship}
            onChange={setCitizenship}
            options={countriesList}
            placeholder={t("select_placeholder_citizenship")}
            icon={<GiPassport />}
          />

          <SearchableSelect
            value={destination}
            onChange={setDestination}
            options={countriesList}
            placeholder={t("select_placeholder_destination")}
            icon={<IoMdGlobe />}
          />
        </FormContainer>
      </ContainerLeft>

      <RenderResultSection
        citizenship={citizenship}
        destination={destination}
        loading={loading}
        result={result}
        getResultType={getResultType}
        // getSelectedCountryName={getSelectedCountryName}
      />
    </Container>
  );
};
